SupportFlexibleEmailFormObjectsTemplate = require '../../../../flexible_email_form_objects.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormIntlDropdownInputView extends Backbone.View
  tagName: 'li'

  events:
    'change .dropdown_input': 'validateEmailForm'

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @isInputFieldEmpty = true
    @maxLength = 250
    @elementID = ".dropdown_input"
    @template = SupportFlexibleEmailFormObjectsTemplate
    @model = @options.model
    @isFlexibleStepThree = @options.isFlexibleStepThree
    @label = @model.label
    @dropdownOptions = @getDropdownOptions(@model.additional_attributes.options)
    @isInputCompulsory = @model.required is true or @model.required is "true"

  render: ->
    @$el.html(toHtml(@template, @toHash()))
    $(@elementID).datepicker()

  getDropdownOptions: (options)->
    dropdownOptions = []
    for option in options
      dropdownOptions.push({id: option, text: option})
    dropdownOptions

  toHash: ->
    stepThreeType: if @isFlexibleStepThree then 'flexibleStepThree' else 'defaultStepThree'
    dropdown_input_template: true
    label: @label
    required: @isInputCompulsory
    maxLength: @maxLength
    options: @dropdownOptions
    counter: @model.counter

  getInputHtmlElement: ->
    @$el.find("#{@elementID} option:selected")

  isInputGiven: ->
    # @getInputHtmlElement().selected
    @readInput()?.length > 0

  readInput: ->
    # @$el.find('.dropdown_input option:selected').val()
    @getInputHtmlElement().val()

  isInputValid: ->
    true

  validateEmailForm: ->
    if @isInputCompulsory && ((@isInputFieldEmpty && @isInputGiven()) || !(@isInputFieldEmpty || @isInputGiven()))
      @isInputFieldEmpty = !@isInputGiven()
      @options.validateEmailForm()

  populateInput: (data)->
    if @isInputGiven()
      inputData = @readInput()
      data.description += "\n\n #{@label} : #{inputData}"

module.exports = EmailFormIntlDropdownInputView
